import React, { useEffect, useRef } from 'react';
import { Container, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, Button, Box, Grid2, ListItemIcon, useTheme } from '@mui/material';
import WebBanner from '../../layouts/WebLayout/components/WebBanner/WebBanner';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Term from '../../assets/images/terms.svg';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from '../../layouts/WebLayout/SkipToMainContent/SkipToMainContentSlice';

const PrivacyPolicy = () => {
  const theme = useTheme();
  const dynamicTextColor = theme.palette.mode === "light" ? "#333333" : "#fff";
  const skipClicked=useSelector((state:any)=>
    {
       return state?.skip?.SkipButtonClicked
   });
const dispatch=useDispatch();
const sectionRef = useRef<HTMLElement | null>(null);
const handleScroll = () => {
   if (sectionRef.current) {
     sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
     dispatch(reset());
   }
 }
 useEffect(()=>{
   if(skipClicked){
   handleScroll() 
   } 
 },[skipClicked])

  const numberStyles = {
    backgroundColor: '#fff',
    color: '#1976d2',
    border: '2px solid #1976d2',
    fontWeight: 'bold',
  };
  return (
    <>
      <WebBanner
        title="Privacy Policy"
        subtitle=" "
        image={Term}
      />
      <Container maxWidth="xl">
        <Box sx={{padding:{ xs:"2rem 0",sm:"1rem 0"}}}>
          <Grid2 container sx={{
            justifyContent: "center"
          }}  ref={sectionRef as any}>
            <Grid2 size={12}  sx={{margin:{ xs:"2rem 0",sm:"3rem 0"}}}>
              <Typography variant="body1" sx={{fontSize:{xs:`calc(1em * var(--dynamic-font-size, 1))`,sm:`calc(1.25em * var(--dynamic-font-size, 1))`}, lineHeight: "40px", color: dynamicTextColor}}>
              This website does not collect any new personal data about the visitor while accessing the website. You can visit this site only with prior registration on Infracon Portal (<a
    href="https://infracon.nic.in"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#1976d2", textDecoration: "underline" }} // optional styling
  >
    https://infracon.nic.in
  </a>). Further, the website may record and log the data like your server's address, the domain name from which you are accessing the site, the type of browser being used, the date & time of access, the page being accessed, the documents downloaded, linking details etc. without your consent. 
              </Typography>
            </Grid2>
          </Grid2>
        </Box>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
